var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"shopping-bag",on:{"click":function($event){return _vm.openCart()}}},[_c('svgicon',{staticClass:"icon",attrs:{"name":"shopping-bag"}}),_vm._v(" "),(_vm.counter > 0)?_c('span',{staticClass:"badge badge--success"},[_vm._v(_vm._s(_vm.counter))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }